import React from 'react';
import { Suggestion } from '@components/common/Suggestion';
import dayjs from 'dayjs';
import { StepProgressBar } from '@fourthwall/components/dist/common/StepProgressBar';
import * as S from './styled';
const formatDate = (date) => {
    return dayjs(date).format('MMMM D');
};
const calculateDaysLeft = (endDate) => {
    const end = dayjs(endDate);
    return end.diff(dayjs(), 'day');
};
export const OngoingCreatorChallengeContainer = ({ current, expected, endAt, reward, }) => (React.createElement(Suggestion, { title: `Sell ${Math.max(expected - current, 0)} more products before ${formatDate(endAt)} to get ${reward} refund`, content: React.createElement(S.CurrentChallengeProgressContainer, null,
        React.createElement(S.ProgressBarContainer, null,
            React.createElement(StepProgressBar, { step: Math.min(current, expected), totalSteps: expected })),
        React.createElement(S.ProgressSubtitles, null,
            React.createElement("span", null,
                current,
                " out of ",
                expected,
                " products sold"),
            React.createElement(S.Counter, null,
                calculateDaysLeft(endAt),
                "\u00A0days left"))) }));
